import React from 'react';
import s from '../../styles/PolicyModal.module.css'; // создадим стиль

function PolicyModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className={s.overlay}>
      <div className={s.modal}>
      <h1 className={s.h1}>Политика конфиденциальности</h1>

<p>
  Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей SaaS-сервиса pulseads.ru.
</p>

<h2>1. Общие положения</h2>
<ul>
  <li>1.1. Политика применяется ко всем персональным данным, которые Оператор получает от Пользователей при использовании Сервиса.</li>
  <li>1.2. Использование Сервиса означает согласие Пользователя с настоящей Политикой.</li>
  <li>1.3. Оператор вправе изменять Политику в одностороннем порядке, размещая актуальную редакцию на Сайте.</li>
</ul>

<h2>2. Оператор данных</h2>
<p>
  Оператором персональных данных является Индивидуальный предприниматель, указанный в реквизитах Сервиса.
</p>

<h2>3. Какие данные обрабатываются</h2>
<p>Сервис может обрабатывать:</p>
<ul>
  <li>имя / логин пользователя;</li>
  <li>email / телефон;</li>
  <li>данные аккаунтов внешних платформ (например Avito);</li>
  <li>данные CRM, загружаемые Пользователем;</li>
  <li>изображения, загружаемые для объявлений;</li>
  <li>технические данные (IP, cookies, логи действий).</li>
</ul>

<h2>4. Цели обработки</h2>
<p>Данные обрабатываются для:</p>
<ul>
  <li>предоставления доступа к SaaS-сервису;</li>
  <li>автоматизации размещения объявлений;</li>
  <li>хранения и обработки загруженных файлов;</li>
  <li>технической поддержки;</li>
  <li>обеспечения безопасности и стабильной работы Сервиса.</li>
</ul>

<h2>5. Обработка данных третьих лиц</h2>
<ul>
  <li>5.1. Пользователь подтверждает, что самостоятельно обеспечивает законность обработки персональных данных третьих лиц (включая конечных клиентов), чьи данные могут быть загружены в Сервис.</li>
  <li>5.2. Пользователь самостоятельно получает все необходимые согласия субъектов персональных данных.</li>
  <li>5.3. Оператор не проверяет наличие таких согласий и не несет ответственности за их отсутствие.</li>
</ul>

<h2>6. Хранение данных</h2>
<ul>
  <li>6.1. Данные хранятся на защищенных серверах в течение срока действия подписки.</li>
  <li>6.2. После окончания подписки данные могут быть удалены по истечении 30 календарных дней.</li>
</ul>

<h2>7. Передача данных третьим лицам</h2>
<p>Данные могут быть переданы:</p>
<ul>
  <li>платежным системам (например YooKassa);</li>
  <li>облачным провайдерам (хостинг, storage);</li>
  <li>сервисам аналитики и инфраструктуры.</li>
</ul>
<p>
  Передача осуществляется только в объеме, необходимом для работы Сервиса.
</p>

<h2>8. Обработка изображений</h2>
<p>
  Загружаемые изображения могут автоматически обрабатываться, включая удаление EXIF-метаданных, не влияющих на визуальное содержание.
</p>

<h2>9. Права пользователя</h2>
<p>Пользователь имеет право:</p>
<ul>
  <li>получать информацию об обработке данных;</li>
  <li>требовать уточнения данных;</li>
  <li>требовать удаления данных в рамках технической возможности Сервиса.</li>
</ul>

<h2>10. Отзыв согласия</h2>
<h3>10.1. Выражение согласия</h3>
<p>
  Пользователь, проходя регистрацию и/или начиная использование Сервиса, выражает согласие на обработку его персональных данных на условиях настоящей Политики в целях предоставления функционала Сервиса, исполнения договора, технической поддержки и соблюдения требований законодательства Российской Федерации.
</p>

<h3>10.2. Маркетинговые и информационные сообщения</h3>
<p>
  Пользователь вправе отдельно дать согласие на получение информационных и маркетинговых сообщений по электронной почте, телефону и иным каналам связи, указанным при использовании Сервиса.
</p>

<h3>10.3. Отзыв согласия</h3>
<p>
  Пользователь может отозвать согласие, направив запрос Оператору, однако отзыв согласия может сделать невозможным использование Сервиса.
</p>

<h2>11. Юридический усиленный блок</h2>
<h3>11.1. Контроль ответственности</h3>
<p>
  Оператор не осуществляет проверку законности данных, загружаемых Пользователем, включая персональные данные третьих лиц.
</p>

<h3>11.2. Риски пользователя</h3>
<p>
  Пользователь несет полную ответственность за нарушение законодательства о персональных данных при использовании Сервиса.
</p>

<h3>11.3. Технический посредник</h3>
<p>
  Сервис выступает исключительно как техническая платформа хранения и обработки данных по поручению Пользователя (data processor / technical intermediary) и не является владельцем данных клиентов Пользователя.
</p>
        <div className={s.button_div}>
        <button className={s.close_button} onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}

export default PolicyModal;
